export const FILTER_NAMES = {
  computedNeedsReview: 'billComputedNeedsReview',
  computedDisposition: 'billComputedDisposition',
};
